import { useEffect, useState } from 'react';
import { adminApi } from '../../lib/api';
import { useAdminAuth } from './AdminLayout';
import { TrendingUp, ShoppingBag, IndianRupee, Package, Award } from 'lucide-react';
import { motion } from 'framer-motion';

export default function AdminDashboard() {
  const { password } = useAdminAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi(password).get('/admin/stats').then((r) => setStats(r.data)).catch(() => {});
  }, [password]);

  if (!stats) return <div className="text-textsecondary font-body">Loading stats...</div>;

  const cards = [
    { label: 'Total Orders', value: stats.total_orders, icon: ShoppingBag, color: 'from-saffron to-golden' },
    { label: 'Revenue', value: `₹${stats.total_revenue.toLocaleString()}`, icon: IndianRupee, color: 'from-maroon to-saffron' },
    { label: 'Pending', value: stats.pending_orders, icon: Package, color: 'from-golden to-golden-light' },
    { label: 'Delivered', value: stats.delivered_orders, icon: TrendingUp, color: 'from-fresh to-emerald-600' },
  ];

  return (
    <div>
      <h1 className="font-heading font-extrabold text-3xl text-textprimary mb-1">Dashboard</h1>
      <p className="text-textsecondary font-body text-sm mb-6">A snapshot of what's cooking today</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {cards.map((c, i) => {
          const Icon = c.icon;
          return (
            <motion.div key={c.label} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }} className={`bg-gradient-to-br ${c.color} rounded-2xl p-5 text-white shadow-warm`} data-testid={`stat-${c.label.toLowerCase().replace(/\s/g, '-')}`}>
              <div className="flex items-center justify-between mb-3">
                <Icon className="w-6 h-6 opacity-90" />
              </div>
              <div className="font-heading font-extrabold text-2xl md:text-3xl">{c.value}</div>
              <div className="text-white/85 text-xs font-body mt-1">{c.label}</div>
            </motion.div>
          );
        })}
      </div>

      <div className="bg-white rounded-2xl p-5 shadow-card border border-borderbeige">
        <div className="flex items-center gap-2 mb-4">
          <Award className="w-5 h-5 text-saffron" />
          <h2 className="font-heading font-bold text-lg text-textprimary">Top Selling Items</h2>
        </div>
        {stats.top_items.length === 0 ? (
          <p className="text-textsecondary font-body text-sm">No sales yet.</p>
        ) : (
          <div className="space-y-3">
            {stats.top_items.map((it, i) => (
              <div key={it.name} className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-gradient-primary text-white font-heading font-bold flex items-center justify-center text-sm">{i + 1}</div>
                  <span className="font-body text-textprimary text-sm">{it.name}</span>
                </div>
                <span className="font-heading font-semibold text-maroon">{it.count} sold</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
